import {
    trackEvent,
    eventNameConstants,
    interactionTypeConstants,
    stepInteractionConstants,
} from 'dibs-tracking';

const { EVENT_PRODUCT_INTERACTION } = eventNameConstants;
const { INTERACTION_TYPE_HOMEPAGE } = interactionTypeConstants;
const { STEP_INTERACTION_DISPLAY } = stepInteractionConstants;

export const VIDEO_MODULE_TRIGGER = 'Video Module';

export const trackVideoModuleDisplay = (): void => {
    trackEvent({
        eventName: EVENT_PRODUCT_INTERACTION,
        interaction_type: INTERACTION_TYPE_HOMEPAGE,
        step_interaction_name: STEP_INTERACTION_DISPLAY,
        trigger: VIDEO_MODULE_TRIGGER,
    });
};

export const trackShopTheEditClick = (): void => {
    trackEvent({
        eventName: EVENT_PRODUCT_INTERACTION,
        interaction_type: VIDEO_MODULE_TRIGGER,
        step_interaction_name: 'Shop the Edit clicked',
        trigger: VIDEO_MODULE_TRIGGER,
    });
};
